var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "payment-summary fsize-13 color-grey4" },
    [
      _c(
        "li",
        {
          staticClass: "fsize-16 text-bold color-grey1 cursor-pointer mb-10",
          on: {
            click: function ($event) {
              _vm.showPayments = !_vm.showPayments
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex gap-2" },
            [
              _vm._v("Informations supplémentaires"),
              _vm.order.payments
                ? _c("CollapseIndicator", { attrs: { open: _vm.showPayments } })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("CollapseTransition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPayments,
                expression: "showPayments",
              },
            ],
          },
          [
            _c(
              "li",
              {
                staticClass: "color-grey4",
                attrs: {
                  "Xv-if": "order.Remain && order.Remain != order.Total",
                },
              },
              [
                _c("div", { staticClass: "shop-details--address mb-5" }, [
                  _vm._v(
                    "\n                    Poste: " +
                      _vm._s(_vm.order.Workstation) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shop-details--address mb-5" }, [
                  _vm._v(
                    "\n                    Nombre de lignes: " +
                      _vm._s(_vm.order.oi.length) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shop-details--address mb-5" }, [
                  _vm._v(
                    "\n                    Document: " +
                      _vm._s(_vm.order.ntik) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shop-details--address mb-5" }, [
                  _vm._v(
                    "\n                    Ticket: " +
                      _vm._s(_vm.order.neId) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-around-center" }, [
                  _c("div", { staticClass: "shop-details--address mb-5" }, [
                    _vm._v(
                      "\n                       " +
                        _vm._s(_vm.order.ClyoVersion) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "shop-details--address mb-5" }, [
                    _vm._v(
                      "\n                       " +
                        _vm._s(_vm.order.SignatureNF) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }